import { NavLink } from 'react-router-dom';
import { theme } from '../theme.js';
import { Icon } from './Icon.js';
import { useAccess } from '../context/AuthContext.js';

export function NavBar() {
  const showAdmin = useAccess().canManage;

  const items = [
    { icon: 'home',   label: 'Home',   to: '/' },
    { icon: 'calendar', label: 'Shifts', to: '/shifts' },
    { icon: 'list',   label: 'Checks', to: '/checks' },
    ...(showAdmin ? [{ icon: 'shield', label: 'Admin', to: '/admin' }] : []),
  ] as const;

  return (
    <div style={{
      borderTop: `1px solid ${theme.border}`,
      background: theme.surface,
      padding: '8px 8px 28px',
      display: 'flex', justifyContent: 'space-around',
      position: 'sticky', bottom: 0, zIndex: 10,
      flexShrink: 0,
    }}>
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.to === '/'}
          style={({ isActive }) => ({
            background: 'transparent', border: 'none', cursor: 'pointer',
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
            padding: '4px 16px', color: isActive ? theme.accent : theme.textMuted,
            fontFamily: theme.font, fontWeight: 600, fontSize: 10,
            textDecoration: 'none',
          })}
        >
          {({ isActive }) => (
            <>
              <Icon name={it.icon} size={22} stroke={isActive ? 2 : 1.7} />
              <span>{it.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </div>
  );
}
